// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import './Contact.css';
// import { useLanguage } from '../context/LanguageContext';
// import Toast from '../components/Toast';

// /* Scroll-reveal hook */
// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
//     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
//     document.querySelectorAll(selector).forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// /* Reusable cinematic hero */
// const PageHero = ({ pill, title }) => (
//   <div className="contact-hero">
//     <div className="contact-hero-bg" />
//     <div className="contact-hero-overlay" />
//     <div className="contact-hero-rays" aria-hidden="true">
//       {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
//     </div>
//     <div className="contact-hero-content">
//       <span className="page-hero-pill">{pill}</span>
//       <h1 className="page-hero-title">{title}</h1>
//       <div className="page-hero-divider">
//         <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
//       </div>
//     </div>
//     <div className="page-hero-bottom-line" />
//   </div>
// );

// const Contact = () => {
//   const { t } = useLanguage();
//   const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
//   const [status, setStatus] = useState({ loading: false, error: null, success: null });
//   const [toast, setToast] = useState(null);

//   useScrollReveal('.reveal');

//   const showToast = (message, type = 'error') => setToast({ message, type });

//   const validateForm = () => {
//     const { name, email, phone } = formData;
//     if (name.trim().length < 3) return t('validation.nameError');
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(email)) return t('validation.emailError');
//     const phoneDigits = phone.replace(/\D/g, '');
//     if (phoneDigits.length !== 10) return t('validation.phoneError');
//     if (!/^[6-9]/.test(phoneDigits)) return t('validation.phoneStartError');
//     return null;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'phone') {
//       setFormData({ ...formData, [name]: value.replace(/\D/g, '').substring(0, 10) });
//       return;
//     }
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationError = validateForm();
//     if (validationError) { showToast(validationError, 'error'); return; }
//     setStatus({ loading: true, error: null, success: null });
//     try {
//       const response = await fetch('https://mhaskobaadmin.tipic.in/api/contact-usstore', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//         body: JSON.stringify(formData),
//       });
//       const result = await response.json();
//       if (!response.ok) throw new Error(result.message || 'काहीतरी चूक झाली');
//       showToast(result.message || 'संदेश यशस्वीपणे पाठवला गेला!', 'success');
//       setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
//       setStatus({ loading: false, success: true, error: null });
//     } catch (err) {
//       showToast(err.message || 'सर्व्हरशी कनेक्ट होऊ शकले नाही', 'error');
//       setStatus({ loading: false, success: null, error: true });
//     }
//   };

//   return (
//     <motion.div 
//       className="contact-page"
//       initial={{ opacity: 0, scale: 0.98 }}
//       animate={{ opacity: 1, scale: 1 }}
//       transition={{ duration: 0.5 }}
//     >
//       {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

//       <PageHero pill={t('nav.contact')} title={t('contact.heroTitle')} />

//       <div className="container">
//         <div className="contact-content reveal">
//           <div className="contact-info-section">
//             {[
//               { titleKey: 'contact.addressTitle', textKey: 'contact.addressText' },
//               { titleKey: 'contact.phoneTitle',   textKey: 'contact.phoneText' },
//               { titleKey: 'contact.emailTitle',   textKey: 'contact.emailText' },
//             ].map(({ titleKey, textKey }, index) => (
//               <div className="info-box reveal" key={titleKey} style={{ '--stagger-index': index }}>
//                 <h3>{t(titleKey)}</h3>
//                 <p>
//                   {t(textKey).split('\n').map((line, i) => (
//                     <React.Fragment key={i}>{line}<br /></React.Fragment>
//                   ))}
//                 </p>
//               </div>
//             ))}
//             <div className="info-box reveal" style={{ '--stagger-index': 3 }}>
//               <h3>{t('contact.timingTitle')}</h3>
//               <p>
//                 {t('contact.timingText').split('\n').map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}
//                 <br />{t('contact.officeTimingTitle')}:<br />
//                 {t('contact.officeTimingText').split('\n').map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="contact-form-section reveal">
//           <h2>{t('contact.formTitle')}</h2>
//           <form className="contact-form" onSubmit={handleSubmit}>
//             <div className="form-row">
//               <div className="form-group">
//                 <label>{t('contact.fullName')}</label>
//                 <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder={t('contact.fullNamePlaceholder')} />
//               </div>
//               <div className="form-group">
//                 <label>{t('contact.emailAddress')}</label>
//                 <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder={t('contact.emailPlaceholder')} />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="form-group">
//                 <label>{t('contact.phoneNumber')}</label>
//                 <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder={t('contact.phonePlaceholder')} />
//               </div>
//               <div className="form-group">
//                 <label>{t('contact.subject')}</label>
//                 <input type="text" name="subject" value={formData.subject} onChange={handleChange} required placeholder={t('contact.subjectPlaceholder')} />
//               </div>
//             </div>
//             <div className="form-group">
//               <label>{t('contact.message')}</label>
//               <textarea name="message" value={formData.message} onChange={handleChange} required rows="6" placeholder={t('contact.messagePlaceholder')} />
//             </div>
//             <button type="submit" className="submit-btn" disabled={status.loading}>
//               {status.loading ? 'Sending...' : t('contact.sendMessage')}
//             </button>
//           </form>
//         </div>

//         <section className="map-section reveal">
//           <h2 className="section-title">{t('contact.findUs')}</h2>
//           <div className="divider" />
//           <div className="map-container">
//             <iframe
//               title={t('contact.mapTitle')}
//               src="https://www.google.com/maps?q=Shri%20Kalbhairavnath%20Mhaskoba%20Maharaj%20Temple%2C%20Kodit%2C%20Purandar%2C%20Pune%2C%20Maharashtra%20412108&output=embed"
//               width="100%" height="400"
//               style={{ border: 0, borderRadius: '15px' }}
//               allowFullScreen="" loading="lazy"
//             />
//           </div>
//         </section>
//       </div>
//     </motion.div>
//   );
// };

// export default Contact;

















import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Contact.css';
import { useLanguage } from '../context/LanguageContext';
import Toast from '../components/Toast';

/* Scroll-reveal hook */
const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

/* Reusable cinematic hero */
const PageHero = ({ pill, title }) => (
  <div className="contact-hero">
    <div className="contact-hero-bg" />
    <div className="contact-hero-overlay" />
    <div className="contact-hero-rays" aria-hidden="true">
      {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
    </div>
    <div className="contact-hero-content">
      <span className="hero-pill-pill">{pill}</span>
      <h1 className="hero-title">{title}</h1>
      <div className="hero-divider">
        <span className="hd-line" /><span className="hd-diamond">◆</span><span className="hd-line" />
      </div>
    </div>
    <div className="hero-bottom-line" />
  </div>
);

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', subject: '', message: ''
  });
  const [status, setStatus] = useState({ loading: false, error: null, success: null });
  const [toast, setToast] = useState(null);

  useScrollReveal('.parchment-card');

  const showToast = (message, type = 'error') => setToast({ message, type });

  const validateForm = () => {
    const { name, email, phone } = formData;
    if (name.trim().length < 3) return t('validation.nameError');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return t('validation.emailError');

    const phoneDigits = phone.replace(/\D/g, '');
    if (phoneDigits.length !== 10) return t('validation.phoneError');
    if (!/^[6-9]/.test(phoneDigits)) return t('validation.phoneStartError');

    return null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      setFormData(prev => ({ ...prev, [name]: value.replace(/\D/g, '').substring(0, 10) }));
      return;
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      showToast(validationError, 'error');
      return;
    }

    setStatus({ loading: true, error: null, success: null });

    try {
      const response = await fetch('https://mhaskobaadmin.tipic.in/api/contact-usstore', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'काहीतरी चूक झाली');

      showToast(result.message || 'संदेश यशस्वीपणे पाठवला गेला!', 'success');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setStatus({ loading: false, success: true, error: null });
    } catch (err) {
      showToast(err.message || 'सर्व्हरशी कनेक्ट होऊ शकले नाही', 'error');
      setStatus({ loading: false, success: null, error: true });
    }
  };

  const infoItems = [
    { key: 'address', titleKey: 'contact.addressTitle', textKey: 'contact.addressText' },
    { key: 'phone',   titleKey: 'contact.phoneTitle',   textKey: 'contact.phoneText' },
    { key: 'email',   titleKey: 'contact.emailTitle',   textKey: 'contact.emailText' },
    { key: 'timing',  titleKey: 'contact.timingTitle',  textKey: 'contact.timingFullText' }, // adjust key if needed
  ];

  return (
    <motion.div
      className="contact-page"
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <PageHero pill={t('nav.contact')} title={t('contact.heroTitle')} />

      <div className="container">

        {/* Four cards in one horizontal line */}
        <section className="contact-info-section">
          {/* <h2 className="section-title">{t('contact.getInTouch')}</h2> */}
          <div className="info-cards-row">
            {infoItems.map((item, index) => (
              <div className="parchment-card" key={item.key} style={{ '--stagger': `${index * 0.12}s` }}>
                <div className="parchment-content">
                  <h3>{t(item.titleKey)}</h3>
                  <div className="parchment-divider" />
                  <p>
                    {t(item.textKey).split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Clean form – no parchment */}
        <section className="contact-form-section">
          <div className="form-container">
            <h2 className="form-title">{t('contact.formTitle')}</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>{t('contact.fullName')}</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.fullNamePlaceholder')}
                  />
                </div>
                <div className="form-group">
                  <label>{t('contact.emailAddress')}</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.emailPlaceholder')}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{t('contact.phoneNumber')}</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.phonePlaceholder')}
                  />
                </div>
                <div className="form-group">
                  <label>{t('contact.subject')}</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder={t('contact.subjectPlaceholder')}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>{t('contact.message')}</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder={t('contact.messagePlaceholder')}
                />
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={status.loading}
              >
                {status.loading ? 'Sending...' : t('contact.sendMessage')}
              </button>
            </form>
          </div>
        </section>

      </div>
    </motion.div>
  );
};

export default Contact;